import React from 'react';
import RenderAppDownload from '../render-app-download';
import './app-download.scss';

const RenderAppDownloadCity = () => (
    <div className="sniff-city-app-download">
        <div className="l-container">
            <RenderAppDownload />
        </div>
    </div>
);

export default RenderAppDownloadCity;
